import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { viewSchemas } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const saveReturnView = {
  name: "saveReturnView" as const,
  input: z.object({
    view: viewSchemas.returns,
    type: createEnum(ReturnTypeEnum),
  }),
  output: z.object({}),
};
